import React from 'react';
import solutionArchitect from '../static/img/aws-certified-solutions-architect-associate.png';
import developerAssociate from '../static/img/aws-certified-developer-associate.png';
import sysopsAdmin from '../static/img/aws-certified-sysops-administrator-associate.png';
import cloudPractioner from '../static/img/aws-certified-cloud-practitioner.png';
import { useMediaQuery } from 'react-responsive';
const sectionTitle = { en: 'Certifications', ja: '資格' };
const Certifications = ({language}) => {
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
	return (
		<div className="py-5">
			<h2 className="text-center sectionTitle">{language === 'English' ? sectionTitle.en : sectionTitle.ja}</h2>
			<div className={`mt-5 d-flex justify-content-end mx-auto ${isTabletOrMobile?null:'w-50'}`}>
				<img src={solutionArchitect} className="certsLogo" alt="awsCertsLogo"/>
				<img src={developerAssociate} className="certsLogo" alt="awsCertsLogo"/>
				<img src={sysopsAdmin} className="certsLogo" alt="awsCertsLogo"/>
				<img src={cloudPractioner} className="certsLogo" alt="awsCertsLogo"/>
			</div>
		</div>
	);
};

export default Certifications;
